// Argus — Lightbox: zoom artifact preview (image / video) via ArgusDialog reusable.

import { Box } from '@mui/material';
import { ArgusDialog } from './floating/ArgusDialog';

export type LightboxKind = 'image' | 'video';

export interface LightboxProps {
  open: boolean;
  onClose: () => void;
  src: string | null;
  alt?: string;
  kind?: LightboxKind;
  useCredentials?: boolean;
}

export function Lightbox({ open, onClose, src, alt, kind = 'image', useCredentials = false }: LightboxProps): JSX.Element {
  const title = kind === 'video' ? 'Video preview' : 'Image preview';
  return (
    <ArgusDialog
      open={open && src !== null}
      onClose={onClose}
      title={title}
      maxWidth="lg"
      contentSx={{
        p: 0,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight: '60vh',
        backgroundColor: 'rgba(0,0,0,0.95)',
      }}
    >
      {src ? (
        kind === 'video' ? (
          <Box
            component="video"
            src={src}
            controls
            preload="metadata"
            crossOrigin={useCredentials ? 'use-credentials' : undefined}
            sx={{ maxWidth: '100%', maxHeight: '80vh', outline: 'none' }}
          />
        ) : (
          <Box
            component="img"
            src={src}
            alt={alt ?? 'screenshot'}
            crossOrigin={useCredentials ? 'use-credentials' : undefined}
            sx={{ maxWidth: '100%', maxHeight: '80vh', objectFit: 'contain' }}
          />
        )
      ) : null}
    </ArgusDialog>
  );
}
